import authsagas from "./auth/sagas";
import signUpSaga from "./formSignUp/sagas";

export default [authsagas(), signUpSaga()];
